<!-- Page Wrapper -->
<div id="wrapper" *ngIf="!hasRoute('login')&& !hasRoute('register')&& !hasRoute('reset-password')&& !hasRoute('forgot-password')">
  <!-- Sidebar -->
  <app-navigation [menuI18n]="menuI18n"></app-navigation>
  <!-- End of Sidebar -->

  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">
    <!-- Main Content -->
    <div id="content">
      <!-- Topbar -->
      <nav
        class="
          navbar navbar-expand navbar-light
          bg-white
          topbar
          mb-4
          static-top
          shadow
        "
      >
        <!-- Sidebar Toggle (Topbar) -->
        <form class="form-inline">
          <button
            id="sidebarToggleTop"
            class="btn btn-link d-md-none rounded-circle mr-3"
          >
            <i class="fa fa-bars"></i>
          </button>
        </form>

        <!-- Topbar Search -->
        <form
          class="
            d-none d-sm-inline-block
            form-inline
            mr-auto
            ml-md-3
            my-2 my-md-0
            mw-100
            navbar-search
          "
        >
          <div class="input-group">
            <input
              type="text"
              class="form-control bg-light border-0 small"
              placeholder="Search for Books, Authors,Categories, Publishers"
              aria-label="Search"
              aria-describedby="basic-addon2"
              #searchInput
            />
            <div class="input-group-append">
              <button
                class="btn btn-primary"
                type="button"
                (click)="search(searchInput.value)"
              >
                <i class="fas fa-search fa-sm"></i>
              </button>
            </div>
          </div>
        </form>

        <app-topbar [menuI18n]="menuI18n"></app-topbar>
      </nav>
      <!-- End of Topbar -->

      <!-- Begin Page Content -->
      <router-outlet></router-outlet>
      <!-- /.container-fluid -->
    </div>
    <!-- End of Main Content -->

    <!-- Footer 
    <app-footer></app-footer>-->
    <!-- End of Footer -->

    <!-- Scroll to Top Button-->
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>
  </div>
  <!-- End of Content Wrapper -->
  <app-chatbot></app-chatbot>

</div>
<!-- End of Page Wrapper -->

<div
*ngIf="!hasRoute('login')&& !hasRoute('register')"
  class="modal fade"
  id="logoutModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        Select "Logout" below if you are ready to end your current session.
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" type="button" data-dismiss="modal">
          Cancel
        </button>
        <a class="btn btn-primary" href="login.html">Logout</a>
      </div>
    </div>
  </div>
</div>

<div *ngIf="hasRoute('login')">
  <app-login (reloadMenu)="reloadMenu()"></app-login>
</div>

<div *ngIf="hasRoute('register')">
  <app-register-user (reloadMenu)="reloadMenu()"></app-register-user>
</div>

<div *ngIf="hasRoute('reset-password')">
  <app-reset-password (reloadMenu)="reloadMenu()"></app-reset-password>
</div>

<div *ngIf="hasRoute('forgot-password')">
  <app-forgot-password (reloadMenu)="reloadMenu()"></app-forgot-password>
</div>


<!-- Bootstrap core JavaScript-->
<script src="assets/vendor/jquery/jquery.min.js"></script>
<script src="assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>

<!-- Core plugin JavaScript-->
<script src="assets/vendor/jquery-easing/jquery.easing.min.js"></script>

<!-- Custom scripts for all pages-->
<script src="assets/js/sb-admin-2.min.js"></script>

<!-- Page level plugins -->
<script src="assets/vendor/datatables/jquery.dataTables.min.js"></script>
<script src="assets/vendor/datatables/dataTables.bootstrap4.min.js"></script>

<!-- Page level custom scripts -->
<script src="assets/js/demo/datatables-demo.js"></script>
